import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

export default function Profile() {
  const [user, setUser] = useState()
  const userToken = jwtDecode(localStorage.getItem('token'))

  const getUser = useCallback(async () => {
    try {
      await fetch('https://pwa.magpiegrove.net/api/api.php?action=user', {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.ok) {
            return response.json()
          }
          throw new Error('error')
        })
        .then((data) => {
          setUser(data.status)
        })
    } catch (error) {
      console.log(error.message)
    }
  }, [])

  useEffect(() => {
    getUser()
  }, [getUser])

  return (
    <div className="profile">
      <h2>Profile</h2>
      {user && (
        <>
          <label>Id: {user.id}</label>
          <label>Firstname: {user.firstname}</label>
          <label>Lastname: {user.lastname}</label>
          <label>Username: {user.username}</label>
          <label>Email: {user.email}</label>
        </>
      )}
      <h2>User from token</h2>
      {userToken && (
        <>
          <label>Firstname: {userToken.user.firstname}</label>
          <label>Lastname: {userToken.user.lastname}</label>
          <label>Username: {userToken.user.username}</label>
          <label>Email: {userToken.user.email}</label>
        </>
      )}
      <Link to="/">Home</Link>
    </div>
  )
}
